import { createFileRoute } from '@tanstack/react-router';
import { TranscriptPage } from '../../../pages/tools/transcript/TranscriptPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/social-transcript')({
  head: () => toolHead('social-transcript'),
  component: () => <TranscriptPage platform="social" />,
});
